import { UnderlyingPriceTrailTacticPanel } from '../../../../components/displays/tradeplans/activeTradePlanModule/components/detailsSection/individualTacticPanels/exits/UnderlyingPriceTrailTacticPanel';
import { AddUnderlyingPriceTrailTacticPanel } from '../../../../components/displays/tradeplans/activeTradePlanModule/components/detailsSection/panels/tacticsPanel/addTacticPanel/individualAddTacticPanels/AddUnderlyingPriceTrailTacticPanel';
import { UnderlyingPriceTrailWrapper } from '../../../../components/displays/tradeplans/softOrderModules/exitTacticModules/UnderlyingPriceTrailModule/wrapper/UnderlyingPriceTrailWrapper';
import UnderlyingPriceTrailDocs from '../../../../components/forms/tradeplans/documentation/UnderlyingPriceTrailDocumentation';
import UnderlyingPriceModule from '../../../../components/forms/tradeplans/tradingPlanFormComponents/FieldComponents/exitTactics/modules/UnderlyingPriceModule';
import { UnderlyingPriceTrailData } from './underlyingPriceTrailData';
import { validateUnderlyingPriceTrail } from './validateUnderlyingPriceTrail';

export const UnderlyingPriceTrail = {
  //data class
  dataStore: UnderlyingPriceTrailData,

  //string constants
  name: 'UNDERLYING_PRICE_TRAIL',
  tacticLabel: 'Underlying Price Trail',
  addTacticLabel: 'Add Underlying Price Trail',
  category: 'Exit',

  // components
  tradePlanFormModule: UnderlyingPriceModule,
  tacticPanel: UnderlyingPriceTrailTacticPanel,
  addTacticPanel: AddUnderlyingPriceTrailTacticPanel,
  wrapper: UnderlyingPriceTrailWrapper,
  chartSoftOrderComponent: UnderlyingPriceTrailWrapper,
  documentation: UnderlyingPriceTrailDocs,
  alertDetailsComponent: null,

  //functions
  setupDetailParser: null,
  validationFunction: validateUnderlyingPriceTrail,
};
